import React, { useCallback } from 'react';
import { Box, MissingDetailOutlineIcon, NavigationToggler, Option, ThinCheckIcon } from '@common-fe/common-fe';
import styled from 'styled-components';

import { ClaimSummaryField } from '@/modules/UseMyMoney/UseMyMoney.types';
import theme from '@/styles/theme';

const StyledNavigationToggler = styled(NavigationToggler)`
  flex: 1;

  &:last-child {
    flex: 1.1;
  }
`;

const MissingDetailWrapper = styled(Box)`
  & span {
    color: ${({ theme }) => theme.colors.missingDetail};
  }
`;

const AddedDetailWrapper = styled(Box)`
  & span {
    color: ${({ theme }) => theme.colors.textBody};
  }
`;

interface Props {
  activeField?: ClaimSummaryField;
  setActiveField: (activeField: string) => void;
  fields: Option[];
}

const FieldSetupHeader: React.FC<Props> = ({ activeField, setActiveField, fields }) => {
  const titleRenderWrapper = useCallback((titleNode: React.ReactNode, key: string) => {
    const isEmptyValue = fields?.find((field) => field.key === key && !field?.value);

    if (isEmptyValue) {
      return (
        <MissingDetailWrapper
          data-testId={`use-my-money-summary_empty-${key.toLocaleLowerCase()}-field`}
          direction="row"
          align="center"
          justify="center"
        >
          {titleNode}
          <Box margin={{ left: 'spacing2' }}>
            <MissingDetailOutlineIcon color="missingDetail" size="16px"/>
          </Box>
        </MissingDetailWrapper>
      );
    }

    return (
      <AddedDetailWrapper
        data-testId={`use-my-money-summary_filled-${key.toLocaleLowerCase()}-field`}
        direction="row"
        align="center"
        justify="center"
      >
        {titleNode}
        <Box margin={{ left: 'spacing2' }}>
          <ThinCheckIcon color="success" size="16px" />
        </Box>
      </AddedDetailWrapper>
    );
  }, [fields]);

  return (
    <StyledNavigationToggler
      testId="use-my-money-summary_field_setup"
      value={activeField as string}
      onChange={setActiveField}
      options={fields}
      titleRenderWrapper={titleRenderWrapper}
      buttonStyle={{
        width: '100%',
        paddingLeft: theme.spacings.spacing6,
        paddingRight: theme.spacings.spacing6,
      }}
      containerStyle={{ width: '100%' }}
      wrapperProps={{ gap: '1px' }}
    />
  );
};

export default FieldSetupHeader;
